import React from 'react'
import PackagingQueue from './PackagingQueue'

const Packaging = () => {
  return (
    <div>
      <PackagingQueue/>
    </div>
  )
}
export default Packaging